import React from "react";
import Rightcontainer from "../Components/Rightcontainer";

const Support = ({ handleShow }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  return (
    <div>
      <div className="leftContainer">
        <div className="supportPage">
          <div className="supportHero">
            <div className="heroIcon">🛡️</div>

            <h2>Support Center</h2>

            <p>Fast • Secure • Reliable Assistance</p>
          </div>

          <div className="supportProfile">
            <div className="profileRing">
              <img src="/support.jpg" alt="Support" className="profileImg" />
              <span className="liveDot"></span>
            </div>

            <h3>MrLudoHub Team</h3>

            <span className="onlineStatus">● Online Now</span>

            <p>Average response time less than 2 minutes</p>
          </div>

          <div className="supportActions">
            <a
              href={`tel:${addCaseSetting.CompanyMobile}`}
              className="supportBtn callBtn"
            >
              <div className="btnIcon">📞</div>

              <div>
                <h4>Call Support</h4>
                <span>Talk with our expert team</span>
              </div>
            </a>

            <a
              href={`https://wa.me/${addCaseSetting.CompanyMobile}`}
              className="supportBtn whatsappBtn"
            >
              <div className="btnIcon">💬</div>

              <div>
                <h4>WhatsApp Support</h4>
                <span>Instant chat assistance</span>
              </div>
            </a>
          </div>

          <div className="featureGrid">
            <div className="featureCard">
              🔒
              <h5>Secure</h5>
              <p>Safe & verified support</p>
            </div>

            <div className="featureCard">
              ⚡<h5>Fast</h5>
              <p>Quick response team</p>
            </div>

            <div className="featureCard">
              🎯
              <h5>Trusted</h5>
              <p>Professional guidance</p>
            </div>

            <div className="featureCard">
              🕒
              <h5>24×7</h5>
              <p>Always available</p>
            </div>
          </div>
        </div>
      </div>
      <div className="rightContainer">
        <Rightcontainer />
      </div>
    </div>
  );
};

export default Support;
